import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ModalEl, VerticalAlignment } from "common/components/modal";
import { SelectEl } from "common/components/select";
import { FileUploaderEl } from "common/components/file-uploader";
import { ButtonTheme } from "common/components/button/constants";
import { SvgIconEl } from "common/components/svg-icon";
import { ConfirmEl } from "common/components/confirm";
import { THEME } from "common/components/confirm/types";
import { QueryBlockEl } from "common/query-builder/query-block/panel";
export function template() {
  const {
    state,
    helpers
  } = this;
  const {
    t
  } = this.getContext("i18n");
  return /* @__PURE__ */ jsx("div", { sel: ".map-lookup-table-modal", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(ModalEl, { attrs: {
    open: this.attr("open"),
    closeable: true,
    "grow-to-content": true,
    "vertical-alignment": this.attr("type") === "import" ? VerticalAlignment.Top : VerticalAlignment.Center
  }, on: {
    change: (ev) => helpers.handleModalClose(ev)
  }, "data-sentry-element": "ModalEl", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".mp-modal-content" }, /* @__PURE__ */ jsx("div", { sel: ".mp-confirm-title" }, helpers.getModalTitle()), /* @__PURE__ */ jsx("div", { sel: ".section-title" }, t("map-lookup-table.lookup-table")), state.selectTableErrorMessage ? /* @__PURE__ */ jsx("div", { sel: ".input-row-error" }, state.selectTableErrorMessage) : null, /* @__PURE__ */ jsx("div", { sel: ".input-row" }, /* @__PURE__ */ jsx("div", { sel: ".select-group", class: {
    hidden: state.hideSelect || this.attr("type") === "import"
  } }, /* @__PURE__ */ jsx(SelectEl, { attrs: {
    sections: helpers.getLookupTableSections(),
    "selected-option": helpers.getSelectedLabel(),
    "search-placeholder": t("common.search"),
    disabled: Boolean(state.fileProcessingDescription),
    elref: "lookupTableSelect"
  }, on: {
    change: helpers.selectLookupTable
  }, "data-sentry-element": "SelectEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx("div", { sel: ".or" }, "or")), /* @__PURE__ */ jsx(FileUploaderEl, { attrs: helpers.getFileUploadBlockAttrs(), on: {
    change: helpers.uploadLookupTableCSV,
    delete: helpers.handleDeleteUpload
  }, "data-sentry-element": "FileUploaderEl", "data-sentry-source-file": "template.tsx" })), /* @__PURE__ */ jsx("div", { sel: ".section-title" }, t("map-lookup-table.map-to-prop")), state.invalidPropertyErrorMessage ? /* @__PURE__ */ jsx("div", { sel: ".input-row-error" }, state.invalidPropertyErrorMessage) : null, state.requireOverwriteConfirmation ? /* @__PURE__ */ jsx("div", { sel: ".input-row-warning" }, t("map-lookup-table.existing-mapping")) : null, /* @__PURE__ */ jsx(QueryBlockEl, { ...helpers.getQueryBlockProps(), onSelect: helpers.handleSelectProperty, onRemove: helpers.handleRemoveProperty, "data-sentry-element": "QueryBlockEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx("div", { sel: ".button-row" }, /* @__PURE__ */ jsx("div", { sel: ".info-link" }, /* @__PURE__ */ jsx("a", { attrs: {
    href: "https://help.mixpanel.com/hc/en-us/articles/360044139291-Lookup-tables",
    target: "_blank"
  }, on: {
    click: helpers.trackInfoClick
  } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "info"
  }, "data-sentry-element": "SvgIconEl", "data-sentry-source-file": "template.tsx" }), t("map-lookup-table.learn-more"))), /* @__PURE__ */ jsx("div", { sel: ".right-buttons" }, /* @__PURE__ */ jsx("div", { sel: ".cancel-button-wrapper" }, /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    theme: ButtonTheme.Tertiary,
    tabindex: 0
  }, on: {
    click: helpers.handleCancel
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, t("common.cancel"))), /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    theme: ButtonTheme.Primary,
    disabled: helpers.shouldDisableConfirm(),
    icon: state.savePending ? "spinner" : "",
    tabindex: 0,
    elref: "applyMappingButton"
  }, on: {
    click: helpers.handleConfirmClick
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, helpers.getConfirmButtonLabel()))), /* @__PURE__ */ jsx(ConfirmEl, { attrs: {
    open: state.overwriteModalOpen,
    closeable: false,
    "remove-host-style": true,
    "grow-to-content": true,
    "not-fullscreen": true,
    "modal-type": "popup",
    title: t("map-lookup-table.overwrite"),
    description: t("map-lookup-table.overwrite-description"),
    theme: THEME.CONFIRM,
    "confirm-button-label": t("common.confirm")
  }, on: {
    submit: helpers.handleConfirmationModal
  }, "data-sentry-element": "ConfirmEl", "data-sentry-source-file": "template.tsx" }))));
}
